import { render, staticRenderFns } from "./AddPointsStartWith.vue?vue&type=template&id=6bac7d06&scoped=true&"
import script from "./AddPointsStartWith.vue?vue&type=script&lang=js&"
export * from "./AddPointsStartWith.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bac7d06",
  null
  
)

export default component.exports